/**
 * Formats an E.164 Australian mobile number for display.
 * "+61477123456" → "0477 123 456"
 */
export const formatMobileNumber = (e164: string): string => {
  const digits = e164.replace(/^\+61/, '0');
  return digits.replace(/(\d{4})(\d{3})(\d{3})/, '$1 $2 $3');
};
